// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import Cookies from '../util/Cookies';
import MessageStore from '../stores/MessageStore';

export class Request {
    baseUrl: string = '';
    instance: any = {
        headers: {}
    }

    constructor() {
		if (process.env.REACT_APP_API_PATH) {
			this.baseUrl = process.env.REACT_APP_API_PATH;

		} else {
			this.baseUrl = 'http://localhost'
		}
    }   


    async get(path: string, headers: any, errorHandling: boolean = true): Promise<any> {

        const token = Cookies.get('token');

        if(token) {
            this.instance.headers['Authorization'] = 'Bearer ' + token;
        }

        this.instance = {
            method: 'GET',
            headers: {
				...headers,
				...this.instance.headers
			}
        }

        const response = await fetch(this.baseUrl + path, this.instance);

        const content = await response.json();
        
        if (errorHandling) {
            this.checkForError(response, content);
         }
        
        return content;
    }

    
    async post(path: string, parameters: any, headers: any, errorHandling: boolean = true): Promise<any> {

        const token = Cookies.get('token');

        if(token) {
            this.instance.headers['Authorization'] = 'Bearer ' + token;
        }

        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        this.instance = {
            method: 'POST',
            body: this.convertParameter(parameters),
            headers: {
				...headers,
				...this.instance.headers
			}
        }

        const response = await fetch(this.baseUrl + path, this.instance);

        const content = await response.json();

        if (errorHandling) {
            this.checkForError(response, content);
        }
        
        return content;
    }

    async put(path: string, parameters: any, headers: any, errorHandling: boolean = true): Promise<any> {

        const token = Cookies.get('token');

        if(token) {
            this.instance.headers['Authorization'] = 'Bearer ' + token;
        }

        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        this.instance = {
            method: 'PUT',
            body: this.convertParameter(parameters),
            headers: {
				...headers,
				...this.instance.headers
			}
        }

        const response = await fetch(this.baseUrl + path, this.instance);

        const content = await response.json();

        if (errorHandling) {
           this.checkForError(response, content);
        }

        return content;
    }

    async delete(path: string, parameters: any, headers: any, errorHandling: boolean = true): Promise<any> {

        const token = Cookies.get('token');

        if(token) {
            this.instance.headers['Authorization'] = 'Bearer ' + token;
        }

        headers['Content-Type'] = 'application/x-www-form-urlencoded';
        this.instance = {
            method: 'DELETE',
            body: this.convertParameter(parameters),
            headers: {
				...headers,
				...this.instance.headers
			}
        }

        const response = await fetch(this.baseUrl + path, this.instance);
        
        if(response.status === 204) {
            return null;
        } 

        const content = await response.json();

        if (errorHandling) {
            this.checkForError(response, content);
         }
        
        return content;
    }

    checkForError(response: any, content: any) {
        if(response.status >= 400) {
            MessageStore.setMessage('error', content.message);
            if ((response.status === 401 || response.status === 403)) {
                Cookies.remove('token', { path: '/' });
                window.location.href = '/?login=true';
            }
        }
    }

    convertParameter(parameters: any): string {
        if(Object.keys(parameters).length === 0) {
            return '';
        }
        var str = [];
        for (var key in parameters) {
            if (parameters.hasOwnProperty(key)) {
                str.push(encodeURIComponent(key) + "=" + encodeURIComponent(parameters[key]))                  
            }
        }
        return str.join("&");
    }

}

export default new Request();